import { render, staticRenderFns } from "./SplitterModalTransference.vue?vue&type=template&id=8afb4368&scoped=true"
import script from "./SplitterModalTransference.vue?vue&type=script&lang=js"
export * from "./SplitterModalTransference.vue?vue&type=script&lang=js"
import style0 from "./SplitterModalTransference.vue?vue&type=style&index=0&id=8afb4368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afb4368",
  null
  
)

export default component.exports